<template>
  <div id="body">
  <div id="mobile_view">
    <AppImageContainer imgSrc="https://p2a-images.s3.amazonaws.com/customers/137/NC_flag.png" imgAlt="North Carolina Flag" imgWidth="45%" imgHeight="100%" />
    <AppImageContainer imgSrc="https://p2a-images.s3.amazonaws.com/customers/137/NC_logo_transparent.png" imgAlt="North Carolina Seal" imgWidth="45%" imgHeight="100%" />
    </div>  
  <div id="image_context_container">
    <AppImageContainer class="desktop" imgSrc="https://p2a-images.s3.amazonaws.com/customers/137/NC_flag.png" imgAlt="North Carolina Flag" imgWidth="45%" imgHeight="75%" />
    <div id="context_section">
    <div><h1>{{getConfig('VUE_APP_VIRTUAL_LOBBY_TITLE')}}</h1>
</div>
<div id="update_statement"><p>As you know, North Carolinians have come together to protest the loss of life of numerous African Americans, including most recently George Floyd. 

As a result of the unrest in our state, lawmakers are considering changes to their work schedule this week. Recognizing the unusual circumstances we are facing, we have made the difficult decision to postpone ourYou’re the Cure Virtual Lobby Day Wednesday, June 3rd. 

As an inclusive organization, we are heartbroken by the events occurring across our country, and we are dedicated to being a relentless force to ensure diversity and inclusion and equitable health for all. The American Heart Association has championed health equity for all people for nearly a century.  We are determined more than ever to eliminate racial and class disparities by lending our voice, platform and resources to the rising chorus for justice.  To read AHA’s statement, please click <a href="https://newsroom.heart.org/news/what-does-the-life-and-death-of-george-floyd-breonna-taylor-and-ahmaud-arbery-mean-for-the-health-of-blacks-in-america">here</a>.

We are committed to making sure you have the opportunity to discuss the need to close the healthcare coverage gap and other important health issues with your lawmaker.  Please stay tuned to your email for further updates.</p></div>
      <p id="lobby_description">{{getConfig('VUE_APP_VIRTUAL_LOBBY_DESCRIPTION')}}</p>
    </div>
    <AppImageContainer class="desktop" imgSrc="https://p2a-images.s3.amazonaws.com/customers/137/NC_logo_transparent.png" imgAlt="North Carolina Seal" imgWidth="45%" imgHeight="100%" />
  </div>      
  <div id="button_container">    
    <AppButton class="nav-btn" btnSrc="https://www.yourethecure.org/north_carolina_state_lobby_day_resources"><span id="button-text">Resources</span></AppButton>
    <AppButton class="nav-btn" btnSrc="https://www.yourethecure.org/nc_lobby_day_schedule_of_events"><span id="button-text">Schedule of Events</span></AppButton>
    <AppButton class="nav-btn" btnSrc="https://act.yourethecure.org/oqgZ22D"><span id="button-text">Find your Lawmakers</span></AppButton>
  </div>  
    <div class="flex">
    <TakeActionBox />
    <LiveMap />
    </div>
    <BannerActivity />
  </div>
</template>

<script>
import LiveMap from '../LiveMap'
import BannerActivity from '../BannerActivity'
import TakeActionBox from './TakeActionBox'
import AppButton from './AppButton'
import AppImageContainer from './AppImageContainer'

export default {
  components: {
    LiveMap,
    TakeActionBox,
    BannerActivity,
    AppButton,
    AppImageContainer
  },
   methods: {
    getConfig(configKey) {
      return process.env[configKey]
    }
   },
};
</script>

<style>

#body {
  display: flex;
  flex-direction: column;
}

#image_context_container {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}

#context_section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

#update_statement {
  white-space: normal;
  line-height: 1.5;
}

@media (min-width: 867px) {
  #context_section {
  width: 46%;
  white-space: nowrap;
   }
}

#button_container {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
}

.flex {
  display: flex;
  flex-direction: row;
  height: 48rem;
}

@media (width: 1024px) and (height: 1366px) {
  .flex{
    height: 64vh;
  }
}

@media (min-width: 1080px) {
  .nav-btn {
    margin-right: 8rem;
  }
}

@media (min-width: 767px) {
  #mobile_view {
    display: none;
  }
}

@media (max-width: 789px) {
  .flex {
    height: 100%;
    flex-direction: column;
    margin-top: 1rem;
  }
  .nav-btn {
    white-space: nowrap;
    align-self: center !important;
    margin: 0px !important;
    width: 12rem;
  }
  #button_container {
     justify-content: space-evenly;
  }
  #image_context_container {
     align-items: flex-start;
  }
}

@media (max-width: 414px) {
   #mobile_view {
     display: flex;
     flex-direction: row;
     justify-content: space-between;
     align-items: center;
     width: 100%
   }
   .desktop {
     display: none;
   }
  .flex {
    margin-top: 0px;
  }
  #lobby_description {
  padding: 0.5rem;
   }
   #button_container {
   flex-direction: column !important;
 } 

}
.nav-btn {
   border: 2px solid #3d3d3d;
   color: #3d3d3d;
   white-space: nowrap;
   align-self: flex-end;
   margin-bottom: 1rem !important;
}

 .nav-btn a {
  color: #3d3d3d;
 }


 #button-text {
   padding: 3px 3px;
 } 

@media (max-width: 320px) {
  .flex {
   width: 21rem; 
  }
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
 #body {
   margin-top: -16rem;  
 }

#button_container {
  margin-top: -15rem;
}

#context_section {
    width: 100%
}

#update_statement {
  white-space: normal;
  line-height: 1.5;
}

 #button-text {
   padding: 12px 3px;
 } 

}

</style>